var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0538 13.0904L18.868 8.94795L20.2469 7.56712C20.6244 7.18904 21.0883 7 21.6385 7C22.1881 7 22.6516 7.18904 23.0292 7.56712L24.408 8.94795C24.7856 9.32603 24.9826 9.78236 24.999 10.3169C25.0154 10.8508 24.8348 11.3068 24.4573 11.6849L23.0538 13.0904ZM7.9849 25C7.70584 25 7.47209 24.9053 7.28365 24.7159C7.09455 24.5272 7 24.2931 7 24.0137V21.2274C7 21.0959 7.02462 20.9687 7.07387 20.8457C7.12311 20.7221 7.19698 20.611 7.29547 20.5123L17.4399 10.3534L21.6257 14.5452L11.4813 24.7041C11.3828 24.8027 11.2722 24.8767 11.1494 24.926C11.0259 24.9753 10.8985 25 10.7672 25H7.9849Z",
    fill: "#71758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/edit-img.025a53f884408692903c76d74b638b57.svg";
export { ForwardRef as ReactComponent };